export default "__VITE_ASSET__BQ3i_mVg__"